<template>
    <div class="c-panel c-panel--small">
        <h3 class="margin-b-24">Account aanmaken</h3>

        <c-form @submit:valid="submit" ref="form">
            <c-password
                name="password"
                id="password"
                required
                v-model="password"
                data-pattern="password"
                data-error-message="Je wachtwoord moet minimaal uit 1 hoofdletter, 1 kleine letter, 1 cijfer en 1 speciale karakter bestaan en minimaal 8 karakters lang zijn"
                autocomplete="new-password"
                :label="'Wachtwoord'"/>

            <c-password
                name="confirm"
                required
                data-pattern="password"
                data-equalto="password"
                v-model="password_confirmation"
                :label="'Herhaal wachtwoord'"/>
                
            <c-button type="submit" class="c-btn--expanded margin-t-32 margin-b-16">Account aanmaken</c-button>

            <p class="text-privacy-statement">Door het activeren van dit account gaat u akkoord met de <a target="blank" href="/img/gebruiksvoorwaarden-d-atz.pdf">gebruikersvoorwaarden</a>.</p>

        </c-form>
    </div>
</template>

<script>
import Form from '@mixins/Form';
import {ValidationError} from '@app/errors';

export default {
    mixins: [Form],
    data() {
        return {
            password: '',
            password_confirmation: ''
        }
    },
    methods: {
        submit() {
            this.$store.dispatch('registration/activate', {
                password: this.password,
                password_confirmation: this.password_confirmation,
                token: this.$route.params.token
            });

            this.$store.dispatch('registration/send').then(() => {
                this.$router.push({name: 'two-factor-authentication'});
            }).catch(e => {
                if (e instanceof ValidationError) {
                    this.$refs.form.setErrors(e.errors);
                } else throw e;
            });
        }
    }
}
</script>
